module.exports = __webpack_public_path__ + "static/media/bg.0545e639.png";